import routesDict from '@/utils/routesDict.js'
import { useHost } from '@/contexts/HostContext'
import { ActiveLink } from '@/components'
import styled from 'styled-components'

const TemplateLink = styled.a`
  display: block;
`

export default function RoutedLink({
  to,
  component: Component = TemplateLink,
  children,
  ...props
}) {
  const host = useHost()

  const origin = `^(http|https):\/\/${host}`
  const relativeAs = to.replace(new RegExp(origin), '')
  const queries = relativeAs.split('?')[1] || ''

  let href = ''
  for (let index = 0; index < routesDict.length; index++) {
    const { reg } = routesDict[index]
    if (reg.test(relativeAs)) {
      href = routesDict[index].route
      break
    }
  }

  return href ? (
    <ActiveLink href={queries ? `${href}?${queries}` : href} as={relativeAs} {...props}>
      <Component {...props}>{children}</Component>
    </ActiveLink>
  ) : (
    <Component href={to} {...props}>
      {children}
    </Component>
  )
}
